import { create } from 'zustand'

export const useGlobalUI = create((set, get) => ({
  // Progress bar state
  progressBar: {
    isVisible: false,
    progress: 0,
    message: '',
    isComplete: false,
    fileName: null,
    fileId: null,
    workflowId: null,
    auditFileData: null,
    capFileData: null,
    companyId: null, // To hold the value of the selected company ID in case there's a selection process
    planId: null,
  },
  
  // Modal state
  modal: {
    isOpen: false,
    title: '',
    content: null,
    size: 'lg',
    onClose: null,
  },
  
  // Progress bar actions
  showProgressBar: (message = 'Loading...', fileName = null, fileId = null, workflowId = null, completionModalOptions = null) => set(state => ({
    progressBar: {
      ...state.progressBar,
      isVisible: true,
      progress: 0,
      message,
      isComplete: false,
      fileName,
      fileId,
      workflowId,
    }
  })),
  
  updateProgress: (progress, message, fileId, workflowId) => {
    set(state => ({
      progressBar: {
        ...state.progressBar,
        progress: Math.min(100, Math.max(0, progress)),
        message: message || state.progressBar.message,
        fileId: fileId || state.progressBar.fileId,
        workflowId: workflowId || state.progressBar.workflowId,
      }
    }))
  },
  
  completeProgress: () => {
    set(state => ({
      progressBar: {
        ...state.progressBar,
        progress: 100,
        isComplete: true,
        message: 'Processing complete!'
      }
    }))
  },
  
  hideProgressBar: () => {
    set(state => ({
      progressBar: {
        ...state.progressBar,
        isVisible: false,
        progress: 0,
        message: '',
        isComplete: false,
        fileId: null,
        workflowId: null,
        fileName: null,
        auditFileData: null,
        capFileData: null,
        companyId: null,
        planId: null,
      }
    }))
  },

  // Modal actions
  openModal: ({ title, content, size = 'lg', onClose = null }) => set({
    modal: {
      isOpen: true,
      title,
      content,
      size,
      onClose,
    }
  }),
  
  closeModal: () => {
    set({
      modal: {
        isOpen: false,
        title: '',
        content: null,
        size: 'lg',
        onClose: null,
      }
    })
  },
  
  // Digitization progress state
  digitizationProgress: {
    isVisible: false,
    progress: 0,
    message: '',
    isComplete: false,
    auditId: null,
    auditName: null,
  },

  startDigitizationProgress: (auditId, auditName = null) => set(state => ({
    digitizationProgress: {
      ...state.digitizationProgress,
      isVisible: true,
      progress: 0,
      message: 'Starting audit analysis...',
      isComplete: false,
      auditId,
      auditName,
    }
  })),

  updateDigitizationProgress: (progress, message) => set(state => ({
    digitizationProgress: {
      ...state.digitizationProgress,
      progress: Math.min(100, Math.max(0, progress)),
      message: message || state.digitizationProgress.message,
    }
  })),

  completeDigitizationProgress: () => set(state => ({
    digitizationProgress: {
      ...state.digitizationProgress,
      progress: 100,
      isComplete: true,
      message: 'Audit analysis complete!',
    }
  })),

  hideDigitizationProgress: () => set(state => ({
    digitizationProgress: {
      ...state.digitizationProgress,
      isVisible: false,
      progress: 0,
      message: '',
      isComplete: false,
      auditId: null,
      auditName: null,
    }
  })),

  // Audit processing specific action
  startAuditProcessing: (uploadData, fileName = 'document.pdf', companyId = null, planId = null) => {
    set(state => ({
      progressBar: {
        ...state.progressBar,
        isVisible: true,
        progress: 0,
        message: 'Uploading and validating document...',
        isComplete: false,
        fileName: fileName,
        fileId: uploadData.auditFileId,
        workflowId: uploadData.workflowId || null,
        auditFileData: uploadData.auditFileData || null,
        capFileData: uploadData.capFileData || null,
        companyId,
        planId,
      }
    }))
  }
}))